// dependencies.
import { get } from 'lodash'

/**
 * Checks if a given user has a given role.
 *
 * @param user
 * @param role
 * @returns {boolean}
 */
export const hasRole = (user, role = 'company') => {
  if (role === 'guest') {
    return true
  }

  const roles = role.split(';')

  return roles.reduce((acc, current) => {
    return acc || get(user, 'type', false) === current
  }, false)
}

/**
 * Get all possible roles.
 * @returns {{admin: string, operator: string, guest: string}}
 */
export const getRoles = () => {
  return {
    admin: 'Administrador'
  }
}

export const getRole = slug => get(getRoles(), slug, slug)



// WEBPACK FOOTER //
// ./src/helpers/user/roles.js